<button mat-raised-button color="primary" [ngClass]="getClasses()" [ngStyle]="getStyles()" class="sidenav-toggle-btn">
    <zui-icon icon="{{icon}}" fxLayoutAlign="center center"></zui-icon>
</button>
